import React from 'react';

//types
import { IIconProps } from 'assets/icons/IconProps';

export const NotificationsListEmpty = ({ width = 218, height = 171 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 218 171"
    fill="none"
  >
    <g clipPath="url(#clip0_257_1069)">
      <path
        d="M25.9387 90.5059H213.861L214.031 90.5117C214.886 90.5691 215.73 91.0467 216.387 91.9199C217.089 92.854 217.499 94.1442 217.5 95.5098V163.5C217.499 164.866 217.089 166.156 216.387 167.09C215.687 168.021 214.772 168.502 213.861 168.504H25.9387L25.7678 168.498C24.9141 168.44 24.0698 167.963 23.4133 167.09C22.7549 166.214 22.3535 165.025 22.3049 163.755L22.3 163.499V95.5098L22.3049 95.2549C22.3535 93.9845 22.7549 92.7957 23.4133 91.9199C24.0698 91.047 24.9141 90.5692 25.7678 90.5117L25.9387 90.5059Z"
        fill="white"
        stroke="#DBDDE0"
      />
      <path
        d="M92.771 121.087H60.1259C58.0527 121.087 56.366 117.892 56.366 113.965C56.366 110.037 58.0527 106.842 60.1259 106.842H92.771C94.8442 106.842 96.5309 110.037 96.5309 113.965C96.5309 117.892 94.8442 121.087 92.771 121.087Z"
        fill="#CACCCF"
      />
      <path
        d="M180.512 136.63H59.2871C58.5123 136.63 57.7693 136.22 57.2215 135.492C56.6737 134.763 56.366 133.775 56.366 132.745C56.366 131.714 56.6737 130.726 57.2215 129.997C57.7693 129.269 58.5123 128.859 59.2871 128.859H180.512C181.287 128.859 182.03 129.269 182.578 129.997C183.126 130.726 183.433 131.714 183.433 132.745C183.433 133.775 183.126 134.763 182.578 135.492C182.03 136.22 181.287 136.63 180.512 136.63Z"
        fill="#DBDDE0"
      />
      <path
        d="M118.293 152.167H59.2871C58.5123 152.167 57.7693 151.757 57.2215 151.029C56.6737 150.3 56.366 149.312 56.366 148.282C56.366 147.251 56.6737 146.263 57.2215 145.534C57.7693 144.806 58.5123 144.396 59.2871 144.396H118.293C119.068 144.396 119.811 144.806 120.359 145.534C120.907 146.263 121.214 147.251 121.214 148.282C121.214 149.312 120.907 150.3 120.359 151.029C119.811 151.757 119.068 152.167 118.293 152.167Z"
        fill="#DBDDE0"
      />
      <path
        d="M192.386 79.3183H4.46194C3.36481 79.3166 2.31297 78.7362 1.53718 77.7044C0.761391 76.6726 0.324995 75.2736 0.32373 73.8144V5.82427C0.324956 4.36503 0.761338 2.96602 1.53714 1.93418C2.31294 0.902344 3.3648 0.321942 4.46194 0.320312H192.386C193.483 0.321995 194.534 0.902415 195.31 1.93424C196.086 2.96607 196.522 4.36505 196.524 5.82427V73.8144C196.522 75.2736 196.086 76.6725 195.31 77.7043C194.534 78.7361 193.483 79.3166 192.386 79.3183Z"
        fill="#EDEDED"
      />
      <path
        d="M71.2947 31.4018H38.6496C36.5763 31.4018 34.8896 28.2065 34.8896 24.279C34.8896 20.3515 36.5764 17.1562 38.6496 17.1562H71.2947C73.3679 17.1562 75.0546 20.3515 75.0546 24.279C75.0546 28.2065 73.3679 31.4018 71.2947 31.4018Z"
        fill="#CACCCF"
      />
      <path
        d="M159.036 46.9422H37.8107C37.036 46.9422 36.293 46.5328 35.7452 45.8042C35.1974 45.0756 34.8896 44.0874 34.8896 43.057C34.8896 42.0266 35.1974 41.0384 35.7452 40.3098C36.293 39.5812 37.036 39.1719 37.8107 39.1719H159.036C159.811 39.1719 160.554 39.5812 161.102 40.3098C161.649 41.0384 161.957 42.0266 161.957 43.057C161.957 44.0874 161.649 45.0756 161.102 45.8042C160.554 46.5328 159.811 46.9422 159.036 46.9422Z"
        fill="#DBDDE0"
      />
      <path
        d="M96.8169 62.4812H37.8107C37.036 62.4812 36.293 62.0719 35.7452 61.3433C35.1974 60.6147 34.8896 59.6265 34.8896 58.5961C34.8896 57.5657 35.1974 56.5775 35.7452 55.8489C36.293 55.1203 37.036 54.7109 37.8107 54.7109H96.8169C97.5916 54.7109 98.3346 55.1203 98.8824 55.8489C99.4302 56.5775 99.738 57.5657 99.738 58.5961C99.738 59.6265 99.4302 60.6147 98.8824 61.3433C98.3346 62.0719 97.5916 62.4812 96.8169 62.4812Z"
        fill="#DBDDE0"
      />
    </g>
    <defs>
      <clipPath id="clip0_257_1069">
        <rect width="218" height="170.04" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
